module.exports = __webpack_public_path__ + "img/EditorialAsphaltThumbnail-400.ffc31eb6.jpg";